import { defaultTheme } from "@cobee/cobee-ui";

const styles = {
  backText: {
    width: "max-content",
    marginBottom: defaultTheme.spacing(2),
    color: defaultTheme.palette.secondary.main,
    cursor: "pointer",
  },
  subtitleStyle: {
    marginTop: defaultTheme.spacing(1),
    color: defaultTheme.palette.grey[700],
  },
};

export default styles;
